// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2GdIb","footer":"ModalFilter_footer__1KO2P"};